import { mockAdapter } from "./mockAdapter";

export const tokenName = "Authorization";

const requestInterceptors = [];
const responseInterceptors = [];

function createConfig(options = {}) {
  const token = localStorage.getItem("erp_admin_token");
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers[tokenName] = token;
  }
  return {
    method: "GET",
    url: "",
    params: {},
    data: {},
    ...options,
    headers
  };
}

function runRequestInterceptors(config) {
  return requestInterceptors.reduce((acc, interceptor) => interceptor(acc), config);
}

function runResponseInterceptors(response) {
  return responseInterceptors.reduce((acc, interceptor) => interceptor(acc), response);
}

async function request(options = {}) {
  const config = runRequestInterceptors(createConfig(options));
  const response = await mockAdapter(config);
  const processed = runResponseInterceptors(response);
  if (processed.code !== 0) {
    return Promise.reject(new Error(processed.msg || "请求失败"));
  }
  return processed.data;
}

request.useRequestInterceptor = function useRequestInterceptor(interceptor) {
  if (typeof interceptor === "function") {
    requestInterceptors.push(interceptor);
  }
};

request.useResponseInterceptor = function useResponseInterceptor(interceptor) {
  if (typeof interceptor === "function") {
    responseInterceptors.push(interceptor);
  }
};

request.get = function get(url, params = {}, options = {}) {
  return request({ ...options, method: "GET", url, params });
};

request.post = function post(url, data = {}, options = {}) {
  return request({ ...options, method: "POST", url, data });
};

request.put = function put(url, data = {}, options = {}) {
  return request({ ...options, method: "PUT", url, data });
};

request.delete = function del(url, data = {}, options = {}) {
  return request({ ...options, method: "DELETE", url, data });
};

export default request;
